<template>
    <div>
        <van-form ref="form" @submit="doLogin">
            <van-field
                v-model="form.account"
                name="账号/手机号"
                label="账号/手机号"
                placeholder="账号/手机号"
                :rules="rules.account"
            />
            <van-field
                v-model="form.password"
                type="password"
                name="密码"
                label="密码"
                placeholder="密码"
                :rules="rules.password"
            />
            <captcha ref="captcha" :captcha="form.captcha"/>
            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import md5 from 'blueimp-md5';
import {doLoginByPwd} from "@/api/CommonApi";
import {Toast} from "vant";
import Captcha from "@/views/my/login/captcha";

export default {
    name: "login-pwd",
    components: {Captcha},
    data() {
        return {
            form: {
                account: '',
                password: '',
                captcha: {
                    key:'',
                    value: ''
                },
                smsLogin:false
            },
            hsId: false,
            hsPwd: false,
            hsCaptcha: false,
            rules: {
                account: [
                    { required: true,  trigger: 'blur' ,message: '请输入账号/手机号'},
                ],
                password: [
                    { required: true,  trigger: 'blur' ,message: '密码在6~16位之间'},
                    { pattern: /^\w{6,16}$/, message: '请输入密码'},
                ],
            },
            captchaUrl: '',
            key: ''
        }
    },
    methods:{
        doLogin() {
            // 表单校验
            const data = Object.assign({},this.form)
            data.password = md5(data.password)
            doLoginByPwd(data).then(res => {
                if(!res.success){
                    throw new Error(res.message)
                }
                localStorage.setItem('token',res.result)
                this.$router.replace('/my')
            }).catch(err => {
                Toast.fail(err.message)
                this.$refs.captcha.changeCaptcha()
            })
        }
    }
}
</script>

<style scoped>

</style>
